import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-b border-gray-200" }
const _hoisted_2 = {
  class: "flex justify-center",
  "aria-label": "Tabs"
}

import { onMounted, ref } from 'vue'
import CheckShift from './CheckShift.vue'
import ShiftChangeHistory from './ShiftChangeHistory.vue'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const headerStore = useHeaderStore()

const tab = ref('historico')

onMounted(() => {
  headerStore.setTitle(
    'Consultar Plantões',
    'Consulte plantões e acompanhe o histórico de trocas realizadas'
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass([
            'border-b-2 w-full',
            tab.value === 'historico' ? 'border-[#2F7F91]' : 'border-transparent'
          ])
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'historico')),
            class: _normalizeClass([
              'py-3 md:py-4 px-2 text-sm md:text-base transition-colors focus:outline-none',
              tab.value === 'historico' ? 'text-gray-900 font-bold' : 'text-gray-500 hover:text-gray-700'
            ])
          }, " Histórico de trocas de plantão ", 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([
            'border-b-2 w-full',
            tab.value === 'consulta' ? 'border-[#2F7F91]' : 'border-transparent'
          ])
        }, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'consulta')),
            class: _normalizeClass([
              'py-3 md:py-4 px-2 text-sm md:text-base transition-colors focus:outline-none',
              tab.value === 'consulta' ? 'text-gray-900 font-bold' : 'text-gray-500 hover:text-gray-700'
            ])
          }, " Consulta de plantões ", 2)
        ], 2)
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(ShiftChangeHistory, {
        "is-active": tab.value === 'historico'
      }, null, 8, ["is-active"])
    ], 512), [
      [_vShow, tab.value === 'historico']
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(CheckShift)
    ], 512), [
      [_vShow, tab.value === 'consulta']
    ])
  ]))
}
}

})